import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, EMPTY, map, Observable, of, tap } from 'rxjs';
import { IEmployee } from '../employee/employee';
import { EmployeeService } from '../employee/services/employee.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentEmployeeResolver  {
  constructor( private employeeService: EmployeeService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IEmployee> {
    return this.employeeService.getEmployeeDetails()
    .pipe(
      tap(x => console.log(x)),
      catchError(err => {
        return EMPTY
      })
    )
  }
}
